module.exports = __webpack_public_path__ + "media/Pascaline.671a3fcf.mp4";